/**
 * @fileoverview Main routes file that combines all route categories.
 * @package PlayItNow
 * @module apps/front/routes
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

import { Routes } from 'react-router-dom'
import { publicRoutes } from './public'
import { fanRoutes } from './fan'
import { adminRoutes } from './admin'

/**
 * @summary Main routes component that combines all route categories.
 * Routes are organized by category for better maintainability.
 */
export function AppRoutes() {
  return (
    <Routes>
      {publicRoutes}
      {fanRoutes}
      {adminRoutes}
    </Routes>
  )
}
